import { render, staticRenderFns } from "./NavbarTitle.vue?vue&type=template&id=31159b35&"
import script from "./NavbarTitle.vue?vue&type=script&lang=js&"
export * from "./NavbarTitle.vue?vue&type=script&lang=js&"
import style0 from "./NavbarTitle.vue?vue&type=style&index=0&id=31159b35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports